export default __webpack_public_path__ + "static/media/Fonciere Truffaut.97acbc03.mp4";